import { AddCircle,  Done, Print } from "@mui/icons-material";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, Collapse, Box, CircularProgress } from "@mui/material";
import { FC, useContext, useEffect, useState} from "react";
import { Fragment } from "react/jsx-runtime";
import { PaymentContext } from "../context/Listprovider";
import EmptyListAlert from "../../../../../EMR/components/layouts/EmptyListAlert";

import AddPayment from "./AddPayment";
import { PaymentData, PayModel } from "../../type";
import { useMutation } from "react-query";
import { addPaymentService, getPrintService, getPrintServicev2 } from "../../Service";
import usePopup from "../../../../../hooks/usePopup";
import { useTheme } from "@mui/material/styles";
import usePrint from "../../../../../hooks/usePrint";
import useAuthentication from "@hooks/useAuthentication";
const PaymentList: FC = () => {
  const theme = useTheme();
  const {user} = useAuthentication()
  
const regionTypeCurrency = user?.region === "QATAR_REGION"?"QAR":"AED";
  const context = useContext(PaymentContext);
  const { printPdf } = usePrint();

  if (!context) {
    throw new Error("VitalsContext must be used within a VitalsProvider");
  }
  const { list,setEdit, setShow, show, amountDetails,setsuccess,balance,setBalance } = context;
  const [cashierId, setCashierId] = useState<number>(0);
  const { showSnackbar } = usePopup()
    const { mutate: getprint ,isLoading:printLoading } = useMutation(getPrintService, {
      onSuccess: (data:any) => {
        printPdf(data.response,"new-tab")
      }
    })

    const { mutate: getprintv2 ,isLoading:printLoadingv2 } = useMutation(getPrintServicev2, {
      onSuccess: (data:any) => {
        printPdf(data.response,"new-tab")
      }
    })
  const { mutate,isLoading,isSuccess} = useMutation(
    addPaymentService,
    {
      onSuccess: (result) => {
        const typedResult = result as { responseIndicator: string; responseMessage: string ,response:{cashierId:number}};
        if (typedResult.responseIndicator == "success") {
          showSnackbar({
            message: typedResult.responseMessage,
            open: true,
            variant: "success",
            duration: 2000,
          });
          setCashierId(typedResult.response.cashierId)
          setsuccess(true);
          setEdit(null);
          
        }
      },
      onError: (e:any) => {
        showSnackbar({
          message: e.response.data.responseMessage,
          open: true,
          variant: "error",
          duration: 2000,
        });
      },
    }
  );

  const handlePrint = (id:number)=>{
    console.log(id)
      if(user?.region == "QATAR_REGION"){
        getprintv2(id)
      }else{
        getprint(id)
      }
  }

useEffect(()=>{
  if(amountDetails?.totalAmount){
    setBalance(amountDetails.totalAmount);
    console.log(amountDetails.patientMasterID);
    
  }
},[amountDetails?.totalAmount])


  const savePayment = () => {
    const paymentData: PaymentData = {
      billNo: amountDetails.billNo,
      clinicId:Number(user?.clinicId),
      amountDetails: {
        totalAmount: amountDetails.totalAmount,
        insDiscount: amountDetails.insDiscount,
        cashSplit: [],
        insAmount: amountDetails.insAmount,
        patShare: amountDetails.patShare,
        currency: regionTypeCurrency
      },
      payModel: list.length > 0 
  ? list : [{
      createdById:Number(user?.userId),
      encounterID: amountDetails.encounterId ?? 0, 
      receivedAmount: amountDetails.patShare,
      balanceAmount: amountDetails.patShare,
      amount: amountDetails.patShare,
      discount: 0,
      netAmount: amountDetails.patShare,
      patientMasterID:amountDetails.patientMasterID
    }]
    }
    mutate(paymentData);
  }

  
  return (
    <TableContainer component={Paper}>
      <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow
            sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
          >
            {heading.map((heading, index) => (
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="left"
                key={`heading${index}`}
              >
                {heading}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
              <EmptyListAlert
                alert="No Details Found"
                isData={Boolean(list.length || show)}
              >
                {(!show && balance>0  ) && (
                  <div className="w-full flex justify-end items-center p-2 gap-3">
                    <Button
                      color="success"
                      endIcon={<AddCircle />}
                      onClick={() => {
                        setShow(true);
                        setEdit(null);
                      }}
                    >
                      Add
                    </Button>
                  </div>
                )}
                {(show &&  balance==0 ||amountDetails?.patShare==0) && (
                  <div className="w-full flex justify-end items-center p-2 gap-3">
                    <Button
                      color="success"
                      disabled={isSuccess}
                      endIcon={
                        isLoading? <CircularProgress
                                     size={18}
                                     sx={{ color: theme.palette.background.paper }}
                                   />: <Done />}
                      onClick={() => {
                        setEdit(null);
                        savePayment()
                      }}
                    >
                      Cash Recieved
                    </Button>

                    {isSuccess && ( 
                        <Button color="error" onClick={() => handlePrint(cashierId)}  endIcon={(printLoading || printLoadingv2) ? <CircularProgress size={18} sx={{ color: theme.palette.background.paper }}/>:<Print />}>
                          Print
                        </Button>
                       )}
                  </div>
                )}
              </EmptyListAlert>
              <Collapse in={show} timeout="auto" unmountOnExit>
                <Box>
                  <AddPayment/>
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
          {list?.map((row: PayModel, index: number) => (
            <Fragment key={`vitalsList${index}`}>
              <TableRow  key={`vitals${index}`}>

                <TableCell>{index + 1}</TableCell>
                <TableCell  sx={{height:"45px"}}>
                  {{ 1: "cash", 0: "card", 2: "wallet" }[row?.paymentType as number] ?? ""}
                  {/* {row?.paymentType} */}
                </TableCell>
                <TableCell>{row.netAmount}</TableCell>
                <TableCell>{row.amount}</TableCell>
                <TableCell>{row.discount ? row.discount : 0}</TableCell>
                <TableCell>{row.receivedAmount}</TableCell>
                <TableCell>{row.balanceAmount}</TableCell>
               
              </TableRow>
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const App: FC = () => {
  return (
    <PaymentList />
  );
};

export default App;

const heading = ["sl no", "Payment Type","Net Amount", "Amount ", "Discount",  "Recieved Amount", "Balance"];

